import styled from "styled-components";
import { sizes, weights } from "../../variables";

export const Wrapper = styled.div`
  box-sizing: content-box;
  height: ${({ height }) => height || '50px'};
  display: flex;

  p {
    margin-top: 0;
    font-family: Julius Sans One;
    font-size: ${({ fontSize }) => fontSize || sizes.xs};
  }

  @media screen and (max-width: 425px) {
    height: 25px;
  }
`;

export const Words = styled.div`
  overflow: hidden;
  font-family: "Julius Sans One";
  font-size: ${({ fontSize }) => fontSize || sizes.xs};
  font-weight: 500;

  span.highlight {
    display: block;
    height: 100%;
    padding-left: 10px;
    animation: spin_words 5s infinite;
    font-weight: ${weights.black};
    background: -webkit-linear-gradient(#FE006E , #245EF3);
    background: -o-linear-gradient(#FE006E, #245EF3);
    background: -moz-linear-gradient(#FE006E, #245EF3);
    background: linear-gradient(to #FE006E, #245EF3 , yellow); 
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @keyframes spin_words {
    10% {
      transform: translateY(-110%);
    }
    25% {
      transform: translateY(-100%);
    }
    35% {
      transform: translateY(-210%);
    }
    50% {
      transform: translateY(-200%);
    }
    60% {
      transform: translateY(-310%);
    }
    75% {
      transform: translateY(-300%);
    }
    85% {
      transform: translateY(-410%);
    }
    100% {
      transform: translateY(-400%);
    }
  }
`;
